export default __webpack_public_path__ + "static/media/Thumb_Accessories_01.e8d68229.png";